export enum RecoveryTypes {
    Leave = "B",
    Employee = "T",
}